import { render } from "./BandejaEntrada.vue?vue&type=template&id=a1df52e6"
import script from "./BandejaEntrada.vue?vue&type=script&lang=js"
export * from "./BandejaEntrada.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__